import {hot} from 'react-hot-loader/root'
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Button } from 'react-bootstrap';
import { displayCustomDialog, base64ToHex } from 'util/Utils';
import { makeRequest, dispatchAction, getCurrentStoreState, displayMessage } from 'actions';
import config from  '../../../config';
import { constructFromObject } from 'paapi5-nodejs-sdk/src/ApiClient';

class ReportWrongUPCButton extends Component {
    
    constructor(props, context) {
        super(props, context);
        this.state = {}
        this.buttonStyle = 'left12 red-button btn btn-primary btn-sm'

    }

   /**
    * Report the wrong upc item to inventory processing app
    * @param {} item 
    */
    reportWrongUPC(item, reason){
        
        let methodDataUPCRequest = {
            endpoint: "/upc_codes",
            'not_display_success_message': true
        }

        return this.props.makeRequest({
            UPCCode: item.UPCCodeRecord.UPCCode,
            lookup: ['GBGProductID']
        }, methodDataUPCRequest).then(res => {
            let upcCode = res.data.data[0];
            const url = `${config.getEnvironment().IPABaseURL}/upc_trouble_bucket/`;
            const variation = this.props.variation? [this.props.variation.value] : upcCode.VariationLinks
            const options = {
                    method: "POST",
                    headers: {
                    'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({upc_trouble_bucket: {
                            tush_upc_code_id: base64ToHex(upcCode._id,{convertToHEXUUID: true}),
                            code: upcCode.UPCCode,
                            brand: upcCode.GBGProductID.Brand,
                            model: upcCode.GBGProductID.Model,
                            variants: upcCode.VariationLinks,
                            reason: reason,
                            resolved: false
                        }
                    })
            };
            fetch(url, options)
            .then((response) => {
                if(response.status != 500){
                    this.props.displayMessage({
                        'messageCode': 'The UPC was submitted to UPC Trouble Bucket'
                    });   
                }else{
                    this.props.displayMessage({
                        'messageCode': 'An error occurred while submitting the UPC.'
                    }); 
                }
            })
        })
    }

    clickEvent(event){
        event.stopPropagation()
        event.preventDefault()                     
        if(this.props.item.UPCCodeRecord){
           this.setState({showReportWrongUPCModal: true})
        }
    }

    render() {
      return (
          <div>
          {displayCustomDialog.call(this, {
            cancelButtonTitle:'Cancel',
            buttonTitle:'Report and Change!',
            cancelActionHandler:()=>{

            },
            confirmActionHandler: (data) => {

                this.reportWrongUPC(this.props.item, this.props.reason).then(response => {})
            },
            modalTitle:'Report and Search for New Product?',
            dialogID: 'ReportWrongUPCModal'
        })}


        <Button 
        onClick={(event) => {this.clickEvent(event)} }

        className={this.buttonStyle}  type="button">
             Report Wrong UPC Match
        </Button>      
        </div>
     );
    }
}


function mapStateToProps(state, props) {
    return {
        userReducer: state.userReducer
    };
}
function mapDispatchToProps(dispatch) {
    return bindActionCreators({makeRequest, getCurrentStoreState, dispatchAction, displayMessage}, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(hot(ReportWrongUPCButton));

